import { render, staticRenderFns } from "./CashNotAccount.vue?vue&type=template&id=6bfa5294&scoped=true&"
import script from "./CashNotAccount.vue?vue&type=script&lang=js&"
export * from "./CashNotAccount.vue?vue&type=script&lang=js&"
import style0 from "./CashNotAccount.vue?vue&type=style&index=0&id=6bfa5294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa5294",
  null
  
)

export default component.exports